module.exports = {
  App: {
    wifi: 'wifi',
    name: '名称',
    number: 'Number',
    phone: 'Phone',
    sms: 'SMS',
    email: 'メールアドレス',
    id: 'ID',
    done: 'Done',
    close: 'Close',
    floor: 'Floor',
    company: 'Organization',
    position: 'Position',
    remarks: 'コメント',
    password: 'Password',
    account: 'アカウント',
    delete: '削除',
    no: 'いいえ',
    yes:'はい',
    bnwk: 'Can not be empty',
    nextStep: 'Next step',
    lastStep: 'Previous step',

    getVerificatioCode: 'Get verification code',
    save: '保存する',

    selectTargeting: '選択',
    jd: 'Lng',
    wd: 'Lat',
    
    view:'view',
    edit:'編集',
    cancel:'キャンセル',
    exit:'キャンセル',
    ok:'確定',
    signOut:'ログアウト',
    pageTitle1: 'スポーツ スタジアム',
    pageTitle2: 'スケジュール設定',
    pageTitle3: 'シーン設定',
    pageTitle4: 'システム設定',
    pageTitle5: 'プロジェクト設定',
    pageTitle6: 'システム本体設定',
    pageTitle7: 'スケジュール',
    pageTitle8: '消費電力',
    
    text1: '登録',

    text8: 'スーパー管理者',
    text9: 'プロジェクトアカウント',
    text10: '実行アカウント',
    text11 : 'アカウントとパスワードを入力してください.',
    text12 : 'シーンを追加しますか？',
    text13 : 'シーンの検索',
    text14 : 'ブートモードが終了、プロジェクトの設定が完了しました',
    text15 : 'Please select project',
    text16 : 'Manage Account',
    text17 : '起動モードを入るかどうか',
    login: {
      text1: 'Welcome to inhealth!',
      text2: 'Happiness and healthiness',
      text3: 'Please enter your log-in name',
      text4: 'Please enter your password',
      text5: 'Please enter the verification code',
      text6: '登録',
      text7: 'パスワードを忘れた',
      text8: 'パスワードを記憶',
      text9: 'Chinese',
      text10: 'English',
    },
    calendar:{
      calendar_text1: '日',
      calendar_text2: '月',
      calendar_text3: '火',
      calendar_text4: '水',
      calendar_text5: '木',
      calendar_text6: '金',
      calendar_text7: '土',
      month1: '1月',
      month2: '2月',
      month3: '3月',
      month4: '4月',
      month5: '5月',
      month6: '6月',
      month7: '7月',
      month8: '8月',
      month9: '9月',
      month10: '10月',
      month11: '11月',
      month12: '12月',

      text1:'execute',
      text2:'前年',
      text3:'前月',
      text4:'翌月',
      text5:'次年',
      text6:'スケジュールの追加',
    },
    systemSetting:{
      text1:'アカウント設定',
      text2:'元アカウント',
      text3:'元パスワード',
      text4:'新アカウント',
      text5:'新パスワード',
      text6:'新パスワードの再確認',
      text7:'Or Identity Settingiginal',
      text8:'全部削除',
      text9:'次へ',
      text10:'タイム・ゾーンの選択',
      text11:'East Eighth Time Zone',
      text12:'East Ten Time Zone',
      text13:'スキン設定',
      text14:'連絡先の設定',
      text15:'故障',
      text16:'連絡先',
      text17:'メールアドレス',
      text18:'温度',
      text19:'保証',
      text20:'Cancel',
      text21:'確定',
      text22:'デフォルトアバター',
      text23:'カスタムアバター',
      text24:'プロフィル変更',
      text25:'適用',
      text26:'シーン追加',
      text27:'調光',
      text28:'制御エリ',
      text29:'スケジュール',
      text30:'プロジェクトリセット',

      text31:'ブートモードをリセットする',
      text32:'プロジェクト情報をリセットする',
      text33:'注:この機能は外部ネットワークに接続しないと使用できません',

      ldentity1:'スーパーアカウント',
      ldentity2:'プロジェクトアカウント',
      ldentity3:'プロジェクトアカウント',
      ldentity4:'営業アカウント',
    },
    subAccountSetting:{
      text1:'サブアカウント設定',
      text2:'サブアカウント設定',
      text3:'Password Change',
      text4:'新パスワードの再確認',
      text5:'ldentity Setting',
      text6:'サブアカウントリスト',
      text7:'連絡先',
      text8:'Identity',
      text9:'コメント',
    },
    sceneSetting:{
      label1:'シーン名称',
      label2:'制御エリ',
      label3:'シーン名称',

      placeholder1:'Mixed court game',

      sceneType1:'調光',
      sceneType2:'マーキー',
      sceneType3:'ストロボ',
      sceneType4:'オープニング',
      sceneType5:'ゴール',
      sceneType7:'色温度',
      
      duration: '維持時間(秒)',
      interval: 'インターバル時間（ミリ秒）',
      sort: 'Sort',

      btn1:'編集',
      btn2:'スケジュール',
      btn3:'削除',
    },
    projectSettings:{
      text1: 'プロジェクト設定',
      text2: 'プロジェクト名称',
      text3: 'プロジェクト場所',
      text4: 'プロジェクト説明',
      text5: 'ゲートウェイ設定',
      text6: '子機設定',
    },
    gatewayInput:{
      text1: 'No.',
      text2: '名称',
      text3: 'ID',
      text4: 'Installaiton Date',
      text5: 'コメント',
      text6: 'wifilist',
      text7: 'wifiName',
      text8: 'wifiPwd',
      text9: 'Lamp Control List',
      text10: 'Select All',
      text11: '有効期限',
      text12: 'Manually add',
      text13: 'Device ID',
    },
    controllerInput:{
      text1: 'No.',
      text2: '名称',
      text3: 'ID',
      text4: 'システム本体',
      text5: 'グループ',
      text6: 'Installaiton Date',
      text7: 'コメント',
      text8: 'ノーマル',
      text9: 'Alarm',
      text10: 'Network',
      text11: '状態',
    },
    groupSetting:{
      text1: 'No.',
      text2: 'グループ',
      text3: 'ID',
      text4: 'コメント',
      text5: 'ライトを選択していません',
      text6: 'There are groups with unselected light',
      text7: 'グループ名称',
      text8: 'ライト',
      text9: '照明制御を追加する',
    },
    schedule:{
      text1: '設定選択',
      text2: '特定時間',
      text3: '太陽時',
      text4: '開始時間',
      text5: '終了時間',
      text6: '開始日',
      text7: '終了日',
      text8: '曜日',
      text9: 'スケジュール',
      text10: 'シーンを選択',

      label1:'日出時刻オフセット',
      label2:'日没時刻オフセット',
      label3:'選択した夕暮れ前の時間から開始',
      label4:'選択した日の出後の時間まで終了',

      timeUnit0:'分',
      timeUnit1:'時',
      
      day0:'日',
      day1:'月',
      day2:'火',
      day3:'水',
      day4:'木',
      day5:'金',
      day6:'土',

    },
    home:{
      text1:'情報',
      text2:'Proiec',
      text3:'オンライン',
      text4:'故障',
      text5:'アウトライン',
      text6:'温度高過ぎ',
      text7:'ホーム',
      text8:'シーン設定',
      text9:'スケジュール設定',
      text10:'システム設定',
      text11:'電力消費量',
      text12:'シーン',
      text13:'グループ',
      text14:'全部のライト',
      text15:'グループ',
      text16:'明るさ',
      text17:'名称',
      text18:'ID',
      text19:'グループ',
      text20:'システム本体',
      text21:'シーン',
      text22:'明るさ',
      text23:'状態',
      text24:'消費電力',
      text25:'電流',
      text26:'Voltage',
      text27:'オンライン',
      text28:'Selected lights',
      text29:'適用',
      text30:'シーン',
      

      nav_btn1:'子機設定',
      nav_btn2:'グループ設定',
      nav_btn3:'システム本体設定', 
      
      btn_text1:'+新プロジェクト',
      

      text:'Selected lights:',

      alarmStatus0:'ノーマル',
      alarmStatus1:'Alarm',

      lightOnline0:'オフライン',
      lightOnline1:'オンライン',

      text31: 'ゲートウェイの説明',
      text32: 'Networking',
      text33: '子機を検索',
      text34: 'ProjectId',
      text35: '	X-coordinate information',
      text36: '	Y-coordinate information',
      text37: '	Expiration time',
      text38: '	Update time',
      text39: '温度(電源)',
      text40: '温度(子機)',
      text41: 'CCT',
    },
    
    
    placeholder: {
      text1: 'Search for username',
      text2: 'Search log description',
      text3: 'Search Name',
      text4: 'Please enter keywords to search',
    },
    sideBar: {
      text1: 'overview',
      text2: 'room',
      text3: 'LED lamp',
      text4: 'line lamp',
      text5: 'Switch panel',
      text6: 'curtain',
      text7: 'Ordinary lamp',
      text8: 'HCL lamp',
      text15: 'sensor',
      text9: 'air purifier',
      text10: 'システム本体',
      text11: 'Alarm maintenance',
      text12: 'Operation Log',
      text13: 'USER',
      text14: 'Hotel Management',
      text16: 'unit',
      text17: 'Units Manager',
      text18: 'UV lamp',

      text19: 'project area',
      text20: 'Air quality testing',
      text21: 'Triliros pipeline sterilizer',
      text22: 'project management',
      text23: 'Grouping',
      text24: 'Device',
    },
    room: {
      text26: '削除',
    },
    retrievePassword: {
      text1: 'パスワードを忘れた',
      text2: 'ユーザー名',
      text3: '認証コード',
      text4: '*アカウントのセキュリティのために,電子メールへの安全なパスワード変更リンクを受け取ります.メールを受け取った後、パスワードを変更できます。.',
      text5: '新しいパスワード:',
      text6: 'メール検証コード:',
      text7: 'コード送信',
    },
    mian_sidebar: {
      accountName: 'ユーザー名:',
      userNav1: '基本情報',
      userNav2: 'パスワードを変更する',
      mailbox: 'メールアドレス',
      verificationCode: '認証コード',
      newPassword: '新しいパスワード',
      confirmPassword: 'パスワードの確認',
    },
    grouping: {
      text1: 'グループリスト'
    },
    message: {
      imgType: '画像ファイルのアップロードはPNG形式もしくはJPEG形式に限定されます',
      text1: 'システムのヒント',
      text2: '確定',
      text3: '削除しますか？',
      text4: 'プロンプト',
      text5: '確定',
      text6: 'キャンセル',
      text7: 'Undelete',
      text8: 'Cannot upgrade',
      text9: 'Devices not online',
      text10: ' is the latest version',
      text11: 'Please select the devices',
      text12: 'Lamp:',
      text13: ' not online',
      text14: ' not bound to gateway',
      text15: 'Device not bound to gateway',
      text16: 'デバイスを削除したいと思いますか？デバイスを削除した後、歴史データも削除されます。バックアップに注意してください。',
      text17: 'Warning',
      text18: 'Canceled',
      text19: 'HCL lights name:',
      text20: 'Sensor name:',
      text21: 'Air purifiers name:',
      text22: 'Device name:',
      text23: 'Unchecked',
      text24: 'ゲートウェイを削除したいのですか？',
      text25: 'Are you sure you want to delete the Logs?',
      text26: '現在の欠陥をマークし、処理することは確実ですか？',
      text27: 'Are you sure you want to delete the alarm profile?',
      text28: 'Are you sure you want to delete the repair personnel?',
      text29: 'Upload the picture only in JPG, PNG format!',
      text30: 'The size of uploaded image cannot exceed 2MB!',
      text31: 'Are you sure you want to delete the users?',
      text32: 'Are you sure you want to delete the room?',
      text33: 'Are you sure you want to delete the build?',
      text34: 'Are you sure you want to delete the floor?',
      text35: 'Are you sure you want to delete the hotel?',
      text36: 'Are you sure you want to delete the plan?',
      text37: 'Bed time should be 4 hours later than wake—up time',
      // text37:'Wake-up time should be 3 hours later than sleeping time',
      text38: 'Please wait for the previous operation to return',
      text39: 'Are you sure to cancel the fault?',
      text40: 'Are you sure you want to clear the working hours?',
      text41: 'ログアウトしますか？',
      delDevText: 'データベースからデバイスの削除を確認します。',
      text42: 'シーンを選択してください。',
      text43: 'リセットを確認？',
      text44: 'リセットキャンセル',
      text45: '正しい緯度を入力してください',
      text48: 'まずアイテムを追加してください。',

      text49: 'ログオフ',
      text50: 'このアカウントは現在ログイン中、相手を強制的にログアウトしますか？',
      text51: 'お客様のアカウントは他の端末でログイン中です',
      text52: 'ログアウトがキャンセルされました',
      text53: 'ログイン成功',
      text54: 'まずゲートウェイを追加してください',
    },
    powerConsumption: {
      text1: '昨日',
      text2: '前週',
      text3: '前月',
      text4: '前年',
      // text5: '确定',
    },
    status: {
      text0:'システム設定',
      text1: 'プロジェクト設定',
      text2: '子機設定',
      text3: 'グループ設定',
      text4: 'シーン設定',
      text5: 'スケジュール設定',
      text6: 'Not set',
      text7: 'Already set',
    }
  }
}